const storage = localStorage

export function getToken(): string {
  return storage.getItem('token') || ''
}

export function setToken(token?: string) {
  if (token === undefined) {
    removeToken()
    return
  }storage.setItem('token', token)
}

export function removeToken() {
  storage.removeItem('token')
}

export function scrollTo(to: number, selector = '.overflow') {
  const els = document.querySelectorAll(selector)
  if (els) {
    els.forEach(el => el.scrollTop = to)
  }
}

export function scrollTop(selector = '.overflow') {
  scrollTo(0, selector)
}

const choiceLabels = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
export function indexToLabel(idx: number) {
  return choiceLabels[idx % choiceLabels.length]
}
